import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,_vm._b({staticClass:"vd-form-input",attrs:{"value":_vm.choiceFieldValue,"items":_vm.items,"multiple":_vm.multiple,"type":undefined,"error-messages":_vm.errorMessages},on:{"change":function($event){return _vm.emitChangeEvent($event)}}},'VSelect',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }